import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-[transform,background-color,border-color,box-shadow,color] duration-150 [transition-timing-function:cubic-bezier(0.23,1,0.32,1)] active:scale-[0.97] motion-reduce:transition-none motion-reduce:active:scale-100 motion-reduce:hover:translate-y-0 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 disabled:active:scale-100 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 [&_svg:last-child:not(:only-child)]:transition-transform [&_svg:last-child:not(:only-child)]:duration-200 hover:[&_svg:last-child:not(:only-child)]:translate-x-0.5 motion-reduce:[&_svg:last-child:not(:only-child)]:translate-x-0",
  {
    variants: {
      variant: {
        default:
          "relative overflow-hidden bg-[#FF6B00] text-white shadow-[0_4px_14px_rgba(255,107,0,0.25)] hover:bg-[#FF8533] hover:-translate-y-0.5 hover:shadow-[0_10px_26px_rgba(255,107,0,0.35)] before:absolute before:inset-0 before:-translate-x-[130%] before:skew-x-[-20deg] before:bg-gradient-to-r before:from-transparent before:via-white/25 before:to-transparent before:transition-transform before:duration-500 before:ease-out before:content-[''] hover:before:translate-x-[130%] motion-reduce:before:hidden",
        destructive:
          "bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90",
        outline:
          "border border-[#CBD2E0] bg-white text-[#0B1533] hover:-translate-y-0.5 hover:border-[#0B1533]/30 hover:shadow-[0_8px_20px_rgba(11,21,51,0.08)]",
        secondary:
          "bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/80",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        link: "text-primary underline-offset-4 hover:underline",
      },
      size: {
        default: "h-9 px-4 py-2",
        sm: "h-8 rounded-md px-3 text-xs",
        lg: "h-10 rounded-md px-8",
        icon: "h-9 w-9",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
